<script lang="ts">
	import DeleteIcon from '../../DeleteIcon.svelte';
	import DuplicateIcon from '../../DuplicateIcon.svelte';
	import { createEventDispatcher } from 'svelte';

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('refresh');
	}

	export let row: any;
	export let mixArray = [];
</script>

<div class="icon-wrap">
	<DuplicateIcon id={row.id} />
	{#if !mixArray.includes(row.name)}
		<DeleteIcon id={row.id} name={row.name} on:dispatchDeleted={dispatchDeleted} />
	{/if}
</div>

<style>
	.icon-wrap {
		display: flex;
	}

	:global(.icon-wrap button, .icon-wrap a) {
		display: inline-block;
		margin-left: 3px;
		margin-right: 3px;
		padding: 1px 6px;
	}
</style>
